import { createAxios, logNative } from '../../utils/utils';
import { PAYGAME_CREATE_ORDER_84, PAYGAME_USER_CTF_84, PAYGAME_PAY_ERSULT_84 } from '../../config';
import React from 'react';
// import Toast from '../../components/Toast/Toast';

export default {
  async createOrder(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(PAYGAME_CREATE_ORDER_84, { params: params });
      return res?.data;
    } catch (err) {
      logNative(`生成单机付费游戏订单失败 params:${JSON.stringify(params)} err: ${err}`);
    }
  },
  async orderPayResult(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(params.queryUrl, { params: params });
      return { ...res?.data, time: +new Date() };
    } catch (err) {
      logNative(`生成单机付费游戏订单失败 params:${JSON.stringify(params)} err: ${err}`);
    }
  },
  async userCertification(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(PAYGAME_USER_CTF_84, { ...params });
      return res?.data;
    } catch (err) {
      logNative(`生成单机付费游戏订单，认证用户失败 params:${JSON.stringify(params)} err: ${err}`);
    }
  },

  // 身份证校验
  checkUserCardId(code) {
    // if (code.length !== 18) {
    //   return true;
    // }
    let format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
    return format.test(code);
  },
};
